/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MotionSensorUpsert
 */
export interface MotionSensorUpsert {
    /**
     * 
     * @type {Date}
     * @memberof MotionSensorUpsert
     */
    firmwareLastUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof MotionSensorUpsert
     */
    currentVersion: string;
}

/**
 * Check if a given object implements the MotionSensorUpsert interface.
 */
export function instanceOfMotionSensorUpsert(value: object): value is MotionSensorUpsert {
    if (!('firmwareLastUpdatedAt' in value) || value['firmwareLastUpdatedAt'] === undefined) return false;
    if (!('currentVersion' in value) || value['currentVersion'] === undefined) return false;
    return true;
}

export function MotionSensorUpsertFromJSON(json: any): MotionSensorUpsert {
    return MotionSensorUpsertFromJSONTyped(json, false);
}

export function MotionSensorUpsertFromJSONTyped(json: any, ignoreDiscriminator: boolean): MotionSensorUpsert {
    if (json == null) {
        return json;
    }
    return {
        
        'firmwareLastUpdatedAt': (new Date(json['firmwareLastUpdatedAt'])),
        'currentVersion': json['currentVersion'],
    };
}

export function MotionSensorUpsertToJSON(json: any): MotionSensorUpsert {
    return MotionSensorUpsertToJSONTyped(json, false);
}

export function MotionSensorUpsertToJSONTyped(value?: MotionSensorUpsert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'].toISOString(),
        'currentVersion': value['currentVersion'],
    };
}

